import { isProcessing } from 'find-and-filter-data/views-schema/public';
import { useCurrentView } from './useCurrentView';
export function useCurrentViewIsProcessing() {
  const view = useCurrentView();
  return isProcessing(view);
}